<template>
  <v-container grid-list-xs fluid>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="d-flex" v-if="!newPres.view">
            <v-autocomplete
              :items="drugGroups"
              single-line
              hide-details
              box
              hide-selected
              item-text="name"
              item-value="id"
              label="Search on drug groups"
              dense
              @change="addDrugGroup"
              return-object
            ></v-autocomplete>
            <v-autocomplete
              class="ml-2"
              :items="drugs"
              single-line
              hide-details
              box
              hide-selected
              item-text="name"
              item-value="id"
              label="Search on drug"
              dense
              @change="addDrug"
              return-object
            ></v-autocomplete>
          </div>
          <v-data-table :headers="headers" :items="newPres.drugs" hide-actions>
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.name }}</td>
                <td>
                  <input class="pa-1 iit" v-model="props.item.route" />
                </td>
                <td>
                  <input class="pa-1 iit" v-model="props.item.duration" />
                </td>
                <td>
                  <input class="pa-1 iit" v-model="props.item.usage" />
                </td>
                <td>
                  <input class="pa-1 iit" v-model="props.item.type" />
                </td>
                <td>
                  <input class="pa-1 iit" type="number" v-model="props.item.quantity" />
                </td>
                <td>
                  <input class="pa-1 iit" type="number" v-model="props.item.price" />
                </td>

                <!-- <td>{{props.item.quantity * props.item.price}}</td> -->

                <td>
                  <v-icon
                    v-if="!newPres.view"
                    color="error"
                    @click="removeDrug(props.item)"
                  >mdi-close</v-icon>
                </td>
              </tr>
            </template>

            <template slot="footer">
              <tr class="footer-row">
                <td colspan="6" class="border-bottom-0"></td>
                <td colspan="1" class="font-weight-bold">Sub Total:</td>
                <td colspan="1">{{sub_total | currency('AFN', 1)}}</td>
              </tr>

              <tr class="footer-row">
                <td colspan="6" class="border-bottom-0"></td>
                <td colspan="1" class="font-weight-bold">Adjustments:</td>
                <td colspan="1">
                  <input class="iit" type="number" v-model="newPres.adjustments" />
                </td>
              </tr>

              <tr class="footer-row">
                <td colspan="6" class="border-bottom-0"></td>
                <td colspan="1" class="font-weight-bold">Total:</td>
                <td colspan="1">{{total | currency('AFN', 1)}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <v-flex xs12 class="text-xs-right mt-3">
          <v-btn flat @click="clean">Close</v-btn>

          <v-btn
            class="mx-0"
            :loading="loading"
            color="primary"
            @click="submit"
            :disabled="!valid"
          >Save</v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      requiredRule: v => !!v || "This field is required.",
      loading: false,
      newPres: {
        adjustments: 0,
        drugs: []
      },
      headers: [
        { text: "Drug Name", value: "name", sortable: false },
        { text: "Route", value: "route", sortable: false },
        { text: "Duration", value: "duration", sortable: false },
        { text: "Usage", value: "usage", sortable: false },
        { text: "Type", value: "type", sortable: false },
        { text: "Quantity", value: "quantity", sortable: false },
        { text: "Price (AFN)", value: "price", sortable: false },
        { text: "", value: "name", sortable: false, width: 50 }
      ]
    };
  },
  computed: {
    presTitle() {
      return this.newPres.view ? "View Prescription" : "New Prescription";
    },
    ...mapGetters({
      drugs: "base/drugs",
      drugGroups: "base/drugGroups"
    }),
    sub_total() {
      return this.newPres.drugs.reduce((prev, curr) => {
        return (prev += curr.price * curr.quantity);
      }, 0);
    },
    total() {
      return parseFloat(this.sub_total) + parseFloat(this.newPres.adjustments);
    }
  },
  methods: {
    print(item) {
      this.$store.commit("doctors/setPrescription", item);
      this.$router.push("/print/prescription");
    },

    removeDrug(drug) {
      this.newPres.drugs.splice(this.newPres.drugs.indexOf(drug), 1);
    },

    addDrugGroup(group) {
      for (const drug of group.drugs) {
        this.addDrug(drug);
      }
    },

    addDrug(drug) {
      this.newPres.drugs.push({
        id: drug.id,
        name: drug.name,
        route: drug.route,
        duration: drug.duration,
        usage: drug.usage,
        type: drug.type,
        quantity: 1,
        price: drug.price
      });
    },

    clean() {
      this.loading=false;
      this.newPres = { adjustments: 0, drugs: [] };
    },

    submit() {
      if (this.newPres.drugs.length === 0) return;
      this.loading=true;

      this.axios
        .post(`/api/prescriptions`, {
          drugs: this.newPres.drugs,
          sub_total: this.sub_total,
          adjustments: this.newPres.adjustments,
          total: this.total,
          status: "confirmed"
        })
        .finally(() => this.clean());
    },

    deletePres(pres) {
      this.$modal.show({
        message: `Are you sure, you want to delete the prescription?`,
        mode: "delete",
        onConfirm: () => {
          this.axios.delete(`/api/prescriptions/${pres.id}`).then(resp => {});
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch("base/loadDrugs");
    this.$store.dispatch("base/loadDrugGroups");
  }
};
</script>

<style>
.iit {
  width: 80px;
}
.border-bottom-0 {
  border-bottom: 1px white solid !important;
}

.footer-row td {
  padding: 0 12px !important;
}
</style>
